var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76644 17.3992C2.66229 17.6049 2.69975 17.8539 2.85978 18.0199C3.01981 18.1858 3.26735 18.2323 3.47668 18.1357L6.1843 16.886C8.45994 15.8357 10.9433 15.3553 13.4224 15.4683C13.4518 16.2644 13.4955 17.0601 13.5535 17.855L13.6276 18.8722C13.6726 19.4893 14.3607 19.8343 14.8821 19.5011C17.1452 18.0551 19.1126 16.1918 20.6794 14.0106L21.178 13.3166C21.3136 13.1278 21.3136 12.8734 21.178 12.6846L20.6794 11.9906C19.1126 9.80938 17.1452 7.9461 14.8821 6.50004C14.3607 6.16688 13.6726 6.51185 13.6276 7.12897L13.5535 8.14618C13.5037 8.82853 13.4645 9.51144 13.4358 10.1947H12.7391C8.8597 10.1947 5.30992 12.3761 3.55741 15.8371L2.76644 17.3992Z",
    fill: "#5F1341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.bdf8eb6c0a2bc89fb5e7d6ade0e0a4eb.svg";
export { ForwardRef as ReactComponent };